import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import BannerUploader from "./BannerUploader";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const useStyles = makeStyles((theme) => ({
	modal: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: 400,
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		padding: theme.spacing(4),
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(2),
		maxHeight: "90vh",
		overflow: "auto",
		[theme.breakpoints.down("sm")]: {
			width: "90%",
			top: 0,
			left: 0,
			transform: "none",
			padding: "16px",
		},
	},
	modalButton: {
		marginTop: theme.spacing(2),
	},
	formControl: {
		width: "100%",
	},
	labelList: {
		marginBottom: theme.spacing(2),
		overflowY: "auto",
	},
	labelItem: {
		display: "flex",
		justifyContent: "space-between",
		padding: theme.spacing(1),
		backgroundColor: theme.palette.grey[200],
		borderRadius: theme.shape.borderRadius,
		marginBottom: "4px",
	},
	labelRemoveButton: {
		cursor: "pointer",
		color: theme.palette.error.main,
	},
}));

const LabelModal = ({
	open,
	onClose,
	onSave,
	initialData,
	uploadImage,
	handleDeleteImg,
}) => {
	const classes = useStyles();

	const [position, setPosition] = useState(1);
	const [productsIds, setProductsIds] = useState([]);
	const [currentId, setCurrentId] = useState("");
	const [image, setImageURL] = useState("");
	const [pendingImage, setPendingImage] = useState(null);
	const [errorMes, setErrorMes] = useState("");

	const [bannerType, setBannerType] = useState("image");

	// Текстовый баннер
	const [textValue, setTextValue] = useState("");
	const [bgColor, setBgColor] = useState("#F54F15");
	const [textColor, setTextColor] = useState("#ffffff");

	// -------- PARSE FUNCTION --------
	const parseTextBanner = (text) => {
		if (!text) return;

		const colorMatch = text.match(/\((#[^,]+),(#[^)]+)\)/);

		if (colorMatch) {
			setBgColor(colorMatch[1]);
			setTextColor(colorMatch[2]);
		}

		// просто обрезаем всё начиная с "("
		const cleanText = text.split("(")[0];

		setTextValue(cleanText);
	};

	// -------- INIT --------
	useEffect(() => {
		if (initialData) {
			// Если редактируем существующий
			setPosition(initialData.position || 1);
			setProductsIds(initialData.productsIds || []);
			setImageURL(initialData.image || "");

			// Определяем тип баннера на основе входящих данных
			const type =
				initialData.text && initialData.text.length > 0 ? "text" : "image";
			setBannerType(type);

			console.log(initialData.text.lenght);

			if (type === "text" && initialData.text) {
				parseTextBanner(initialData.text);
			}
		} else {
			// Если создаем новый — сбрасываем форму
			clearForm();
		}
		// bannerType УДАЛЕН из зависимостей, чтобы не сбрасывать форму при переключении
	}, [initialData]);
	// -------- HANDLERS --------
	const clearForm = () => {
		setPosition(1);
		setProductsIds([]);
		setCurrentId("");
		setImageURL("");
		setPendingImage(null);
		setBannerType("image");
		setTextValue("");
		setBgColor("#F54F15");
		setTextColor("#ffffff");
		setErrorMes("");
	};

	const handleAddLabel = () => {
		if (!currentId.trim()) return;
		setProductsIds([...productsIds, currentId]);
		setCurrentId("");
	};

	const handleRemoveLabel = (id) => {
		setProductsIds(productsIds.filter((item) => item !== id));
	};

	const handleImageUpload = (img) => {
		setPendingImage(img);
		setErrorMes("");
	};

	const handleSave = async () => {
		const isActive =
			initialData?.isActive !== undefined ? initialData?.isActive : true;

		// Создаем базовый объект
		const payload = {
			isActive,
			position,
			productsIds,
		};

		if (bannerType === "image") {
			let finalImageURL = image;

			if (!image && !pendingImage) {
				setErrorMes("Изображение обязательно");
				return;
			}

			if (pendingImage) {
				finalImageURL = await uploadImage(pendingImage);
			}

			// Явно фиксируем: картинка есть, текста НЕТ
			payload.image = finalImageURL;
			payload.text = "";
		} else if (bannerType === "text") {
			if (!textValue.trim()) {
				setErrorMes("Введите текст баннера");
				return;
			}

			const formatted = `${textValue}(${bgColor},${textColor})`;

			// Явно фиксируем: текста есть, картинки НЕТ
			payload.text = formatted;
			payload.image = "";
		}

		// Отправляем ОДИН сформированный объект
		console.log("Saving payload:", payload); // Проверьте в консоли, что летит в базу
		onSave(payload);

		clearForm();
		onClose();
	};
	return (
		<Modal open={open} onClose={onClose}>
			<Box className={classes.modal}>
				<Typography variant="h6">
					{initialData ? "Редагувати лейбл" : "Додати новий лейбл"}
				</Typography>

				<FormControl className={classes.formControl}>
					<InputLabel>Позиція</InputLabel>
					<Select
						value={position}
						onChange={(e) => setPosition(e.target.value)}
					>
						{[1, 2, 3, 4].map((pos) => (
							<MenuItem key={pos} value={pos}>
								{pos}
							</MenuItem>
						))}
					</Select>
				</FormControl>

				<TextField
					label="Додати ID товара"
					value={currentId}
					onChange={(e) => setCurrentId(e.target.value)}
					fullWidth
				/>

				<Button variant="contained" onClick={handleAddLabel}>
					Додати
				</Button>

				<Box className={classes.labelList}>
					{productsIds.map((id) => (
						<Box key={id} className={classes.labelItem}>
							<Typography>{id}</Typography>
							<Button
								className={classes.labelRemoveButton}
								onClick={() => handleRemoveLabel(id)}
							>
								Удалить
							</Button>
						</Box>
					))}
				</Box>

				<RadioGroup
					value={bannerType}
					onChange={(e) => setBannerType(e.target.value)}
					row
				>
					<FormControlLabel
						value="image"
						control={<Radio color="primary" />}
						label="Баннер"
					/>
					<FormControlLabel
						value="text"
						control={<Radio color="primary" />}
						label="Текст"
					/>
				</RadioGroup>

				{/* IMAGE */}
				{bannerType === "image" && (
					<BannerUploader
						image={image}
						setImageURL={setImageURL}
						handleImageUpload={handleImageUpload}
						handleDeleteImg={handleDeleteImg}
						errorMes={errorMes}
					/>
				)}

				{/* TEXT */}
				{bannerType === "text" && (
					<>
						<TextField
							label="Текст баннера"
							value={textValue}
							onChange={(e) => setTextValue(e.target.value)}
							fullWidth
						/>

						<Box display="flex" gap={2} mt={1}>
							<Box style={{ marginRight: "10px" }}>
								<Typography variant="body2">Колір фону </Typography>
								<input
									type="color"
									value={bgColor}
									onChange={(e) => setBgColor(e.target.value)}
								/>
							</Box>

							<Box style={{ marginRight: "10px" }}>
								<Typography variant="body2">Колір тексту</Typography>
								<input
									type="color"
									value={textColor}
									onChange={(e) => setTextColor(e.target.value)}
								/>
							</Box>
						</Box>

						{/* PREVIEW */}
						<Box
							mt={2}
							p={2}
							style={{
								backgroundColor: bgColor,
								color: textColor,
								borderRadius: "6px",
								textAlign: "center",
								fontWeight: 600,
							}}
						>
							{textValue || "Превью баннера"}
						</Box>
					</>
				)}

				<Button
					variant="contained"
					color="primary"
					onClick={handleSave}
					className={classes.modalButton}
				>
					{initialData ? "Зберегти" : "Додати"}
				</Button>

				<Button
					variant="outlined"
					onClick={onClose}
					className={classes.modalButton}
				>
					Відміна
				</Button>
			</Box>
		</Modal>
	);
};

export default LabelModal;
